import { Context } from '@vue-storefront/core';
import type { ApiResult, GoodInfo, SkuDetails, SkuProps, SkuPropValues } from '../../types';

export default async function goodInfo({ client, config }: Context, goodId: number): Promise<ApiResult> {
  const url = new URL('/mall/good/info', config.api.url);
  const data1 = await client.post(url.href, { good_id: goodId });
  // console.log('-----goodInfo结果', goodId, data1);
  const res = data1.data;
  const data = data1.data.data;
  if (data && data.good_id) {
    const goodData: GoodInfo = {
      goodId: data.good_id,
      shopID: data.shop_id,
      viewID: data.view_id,
      catId: data.cat_id,
      title: data.title,
      desc: data.desc,
      note: data.note,
      videoUrl: data.video_url,
      imageUrl: data.image_url,
      imageUrl1: data.image_url_1,
      imageUrl2: data.image_url_2,
      imageUrl3: data.image_url_3,
      imageUrl4: data.image_url_4,
      isInWishlist: data.is_in_wish_list,
      createTime: data.create_time,
      updateTime: data.update_time,
      rate: data.rate,
      skus: [],
      skuProps: [],
      priceMin: data.price_min,
      priceMax: data.price_max,
      slug: '',
      goodInfos: data.good_infos,
      subTitle: data.sub_title,
      cId: data.cid,
      relateGoods: data.relate_goods,
      imageUrl5: data.image_url_5,
      imageUrl6: data.image_url_6,
      imageUrl7: data.image_url_7,
      imageUrl8: data.image_url_8,
      imageUrl9: data.image_url_9,
      discountRatio: data.discount_ratio,
      discountPriceMin: data.discount_price_min,
      discountPriceMax: data.discount_price_max,
      catTree: [],
      shopName: data.shop_name,
      shopDomain: data.shop_domain,
      exchangeRate: data.exchange_rate,
      shippingPeriod: data.shipping_period,
      keywords: data.keywords
    };
    if (data.cat_tree) {
      data.cat_tree.forEach((x) => {
        const catInfo = {
          catId: x.cat_id,
          shopId: x.shop_id,
          name: x.name,
          pCatId: x.p_cat_id,
          weight: x.weight,
          imageUrl: x.image_url,
          viewId: x.view_id,
          slug: x.slug,
          ai: x.ai
        };
        goodData.catTree.push(catInfo);
      });
    }
    if (data.skus) {
      data.skus.forEach((y) => {
        const skuData: SkuDetails = {
          skuId: y.sku_id,
          shopId: y.shop_id,
          goodId: y.good_id,
          propsIds: y.props_ids,
          price: y.price,
          stockNum: y.stock_num,
          outId: y.out_id,
          barcode: y.barcode,
          taxRate: y.tax_rate,
          skuImage: y.sku_image,
          viewId: y.view_id,
          originalPrice: y.original_price
        };
        goodData.skus.push(skuData);
      });
    }
    if (data.sku_props) {
      data.sku_props.forEach((z) => {
        const skuProps: SkuProps = {
          propId: z.prop_id,
          propName: z.prop_name,
          imgUrl: z.img_url,
          viewId: z.view_id,
          values: []
        };
        if (z.values) {
          z.values.forEach((v) => {
            const skuPropValues: SkuPropValues = {
              valueId: v.value_id,
              propValue: v.prop_value,
              viewId: v.view_id,
              imgUrl: v.image_url
            };
            skuProps.values.push(skuPropValues);
          });
        }
        goodData.skuProps.push(skuProps);
      });
    }

    res.data = goodData;
  }

  // console.log('-----goodInfo----res', res);

  return res;
}
